import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-super-admin-edit',
  templateUrl: './super-admin-edit.component.html',
  styleUrls: ['./super-admin-edit.component.scss']
})
export class SuperAdminEditComponent implements OnInit {
  //private BASE_URL: string = 'http://localhost:4200/';
  private BASE_URL: string = environment.BASEURL;
  submitted = false;
 errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
 data={};userData="";closeResult: any = '';
 is_active='1';
 organisationData:any;
 userID:any;
 adminData:any;order_by:any='created_dttm';order:any='ASC';
 emailError:string='';
 phoneError:string='';
 userDetail: any;
 content: any='update';
  checkboxValue: any;
  isChecked: any;
  isCheckeds:any = false;
  checkedValidation:any = 0;
  accessError:any=0;
 constructor(private contentAuthoringApi:ContentAuthoringService,
   private route: ActivatedRoute,
   private router: Router,private spinner: NgxSpinnerService,private modalService: NgbModal) {
     if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
       this.router.navigateByUrl('/admin-login');
     }
    }
    userForm = new FormGroup({
      first_name: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z-. ]*$")]),
      last_name: new FormControl('', [Validators.pattern("^[a-zA-Z-. ]*$")]),
      email: new FormControl('', [Validators.required, Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]),
      created_by: new FormControl('2'),
      change_pass_link: new FormControl(this.BASE_URL + '/#/create_password'),
      //change_pass_link: new FormControl(this.BASE_URL + '/create_password'),
      //organisation_id: new FormControl('', Validators.required),
      backend_user_mgmt: new FormControl(''),
      content_authoring_access: new FormControl(''),
      course_mgmt_access: new FormControl(''),
      user_mgmt_access: new FormControl(''),
      organisation_mgmt_access: new FormControl(''),
      reset_rqsts_access: new FormControl(''),
      reports_access: new FormControl(''),
      settings_access: new FormControl(''),
      assessment_access: new FormControl(''),
      ticket_access: new FormControl(''),
      user_type:new FormControl(2),
    });
   get f() { return this.userForm.controls; } 

 ngOnInit(): void {
   this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
   this.route.queryParams.subscribe(params => {
     const id = +params.id;
     if (id > 0) {
      console.log(id);
      this.userID = id;
      this.getUserDetail(this.userID);
      this.userForm.controls.email.disable();
     }
 });
 }
 
 open(content: any) {
   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
     this.closeResult = `Closed with: ${result}`;
   }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
   });
 }
 private getDismissReason(reason: any): string {
   if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
   } else {
     return `with: ${reason}`;
   }
 }


/*get user lidting data********/
getUserDetail(userID:any) {
 this.spinner.show();
 this.contentAuthoringApi.getAdminUserDetail(userID).subscribe(
   (data) => {
     console.log(data);
     this.userDetail=data.userList;
     if (data.success) {
       this.spinner.hide();
       this.userForm.patchValue({
         first_name: data.userList.first_name,
         last_name:data.userList.last_name,
         phone:data.userList.phone,
         email:data.userList.email,
        // organisation_id:data.userList.organisation_id,
         backend_user_mgmt:data.userList.backend_user_mgmt,
         content_authoring_access:data.userList.content_authoring_access,
         course_mgmt_access:data.userList.course_mgmt_access,
         user_mgmt_access:data.userList.user_mgmt_access,
         organisation_mgmt_access:data.userList.organisation_mgmt_access,
         reset_rqsts_access:data.userList.reset_rqsts_access,
         reports_access:data.userList.reports_access,
         settings_access:data.userList.settings_access,
         assessment_access:data.userList.assessment_access,
         ticket_access:data.userList.ticket_access,
        // user_type:data.userList.user_type
        // created_by:data.userList.first_name,
       });

     } else {
       this.spinner.hide();
       this.errorInfo.isError = true;
       this.errorInfo.errorMsg = 'No data Exist'
     }
   },
   (error) => {
     this.spinner.hide();
     this.errorInfo.errorMsg = error;
   },
 );
}


  /*******create customer user (normal user)******/
  editUser(userForm:any)
  {
    this.spinner.show();
    this.submitted = true;
    if(this.userForm.value.phone.length != 10 && this.userForm.value.phone.length != 0){
      this.phoneError = 'Please input valid phone number'; 
    }else{ this.phoneError = ''; }
    if(this.userForm.invalid) { this.spinner.hide(); return; }
    if(this.checkedValidation == 0){
      this.accessError = 1
      this.spinner.hide();
      return;
    }
    this.contentAuthoringApi.editAdminUser(this.userForm.getRawValue()).subscribe(
      (data)=>{
        this.emailError = ''; this.phoneError = '';
       // console.log(data);return false;
      if(data.status == 201 || data.status == 200){
     
        this.spinner.hide();
        document.getElementById('successMsg')?.click();
         this.router.navigateByUrl('/super-admin'); 
      }
      else if(data.email_error || data.phone_error){
        this.spinner.hide();
        this.errorInfo.isError = true;
        this.emailError = data.email_error;
        this.phoneError = data.phone_error;
      }else{
        this.spinner.hide();
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'Something went wrong';
      }
      },
      (error) => { 
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    ); 
  }
  
 logout(){
  // localStorage.clear();
   localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
   this.router.navigate(['./admin-login']);
  }
  onChange(ob: MatCheckboxChange) {

   this.checkboxValue = ob.source.id;
   this.isChecked = ob.checked
    if (this.checkboxValue == "backend_user_mgmt" && this.isChecked) {
      this.isCheckeds= true;
    }
    if (this.checkboxValue == "backend_user_mgmt" && !this.isChecked) {
      this.isCheckeds= false;
    }
    if(this.isChecked){
      this.checkedValidation = 1;
    }
    if(!this.isChecked){
      this.checkedValidation = 0;
    }
   
  }
}